import { Container } from "@babylonjs/gui/2D/controls/container.js";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
import { TextWrapping } from "@babylonjs/gui/2D/controls/textBlock.js";
import { ObjectBuilder } from "@dreamcam/babylon-tools";
import { Env } from "../../settings/Env";
export class MessageContainer extends Container {
    get textBlock() {
        return this._textBlock;
    }
    constructor(name, messageText, presentation, mesh2D) {
        super(name);
        this._textBlock = ObjectBuilder.createTextBlock3D(mesh2D, "messageText", messageText, {
            horizontalAlignment: Control.HORIZONTAL_ALIGNMENT_CENTER,
            verticalAlignment: Control.VERTICAL_ALIGNMENT_CENTER,
            textHorizontalAlignment: Control.HORIZONTAL_ALIGNMENT_CENTER,
            textVerticalAlignment: Control.VERTICAL_ALIGNMENT_CENTER,
            textWrapping: TextWrapping.WordWrap,
            fontFamily: Env.fontFamily,
            color: presentation.text.color,
            fontSize: presentation.text.fontSize,
            fontWeight: presentation.text.fontWeight,
            resizeToFit: true
        });
        this.addControl(this._textBlock);
    }
}
